import { css, StyledProps } from '@emotion/react';
import styled from '@emotion/styled';
import { ResponsiveImage } from '../../components/ResponsiveImage';
import { media } from '../../services/media';

const SectionUpscore = ({ theme }: StyledProps) =>
    theme.version === 'upscore' &&
    css`
        padding: 60px 0;
    `;

const SectionPengestyrke = ({ theme }: StyledProps) =>
    theme.version === 'pengestyrke' &&
    css`
        position: relative;
        color: #ffffff;
        background-color: #133143;

        max-width: 1200px;

        ${media.max('md')} {
            margin: 20px auto;
            padding: 30px 15px;
        }

        ${media.min('md')} {
            padding: 50px 35px;
            margin: 0 auto 100px;
        }
    `;

export const Section = styled.section`
    font-family: ${(props) => props.theme.body.fontFamily};

    ${SectionUpscore}
    ${SectionPengestyrke}
`;

export const Entries = styled.div`
    display: grid;
    gap: 20px;
    padding: 40px 0;

    ${media.max('md')} {
        grid-template-columns: 1fr;
    }

    ${media.between('md', 'lg')} {
        grid-template-columns: repeat(2, 1fr);
    }

    ${media.min('lg')} {
        grid-template-columns: repeat(3, 1fr);
    }
`;

const EntryUpscore = ({ theme }: StyledProps) =>
    theme.version === 'upscore' &&
    css`
        border-radius: 40px;
    `;

const EntryPengestyrke = ({ theme }: StyledProps) =>
    theme.version === 'pengestyrke' &&
    css`
        background-color: #eef0eb;
    `;

export const Entry = styled.div`
    background-color: #dfdfdf;
    width: 100%;
    font-weight: 400;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    cursor: pointer;

    max-width: 100%;
    padding: 16px 15px 15px 15px;

    ${media.min('lg')} {
        padding: 26px 32px;
    }

    ${EntryUpscore}
    ${EntryPengestyrke}

    &::after {
        content: '>';
        position: absolute;
        top: 50%;
        right: 24px;
        transform: translateY(-50%);
        color: inherit;
    }
`;

export const EntryIcon = styled(ResponsiveImage)`
    max-width: 100%;
    width: 24px;
    height: 24px;
    margin: 0 10px 0 0;

    img {
        max-width: 100%;
    }
`;

export const TemporaryInformation = styled.div`
    padding: 30px 40px;
    background: #dfdfdf;

    ${media.max('lg')} {
        margin: 0 0 20px;
    }

    ${media.min('lg')} {
        margin: 0 0 40px;
    }

    p {
        margin: 0;
    }
`;

export const Heading = styled.div`
    h1,
    h2,
    h3,
    h4,
    h5 {
        margin: 0 0 0.5em;
    }
`;

export const Content = styled.div``;
